export default {
	"address.buttonClick": "button click",
	"address.edit": "edit",
	"address.New": "New",
	"address.NewRevenueAddress": "New revenue address"
}